import { Color } from '../enums/color'
import { commonTheme } from './_commonTheme'

export const lightTheme = {
  ds: {
    colors: {
      base: {
        background: Color.White,
        textPrimary: Color.Black,
        textSecondary: Color.Grey700,
        icon: Color.Grey500,
      },
      pricing: {
        accent: Color.Green400,
      },
    },
    ...commonTheme,
  },
}
